import { AxiosResponseHeaders } from 'axios';
import { SwiftCode, SwiftCodeResponseDTO } from '../entities';

const swiftCodesResponseDTOToSwiftCodesAdapter = (
  data: SwiftCodeResponseDTO,
  headers?: AxiosResponseHeaders,
): SwiftCode[] => {
  if (!data.body) {
    throw new Error('Error');
  }

  return data.body.swiftCodes.map(
    sc =>
      new SwiftCode(
        sc.address,
        sc.address2,
        sc.address3,
        sc.bankDept,
        sc.bankDescr,
        sc.bic,
        sc.centralBank,
        sc.city,
        sc.country,
        sc.country2,
        sc.extraAddrInfo,
        sc.location,
        sc.pob,
        sc.prefix,
        sc.subInfo,
        sc.swiftConnFlag,
        sc.valueAdded1,
        sc.valueAdded2,
        sc.zipCodeTown,
      ),
  );
};

export { swiftCodesResponseDTOToSwiftCodesAdapter };
